import { render, staticRenderFns } from "./Model-content.vue?vue&type=template&id=9aff0258&scoped=true&lang=pug"
import script from "./Model-content.vue?vue&type=script&lang=js"
export * from "./Model-content.vue?vue&type=script&lang=js"
import style0 from "./Model-content.vue?vue&type=style&index=0&id=9aff0258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aff0258",
  null
  
)

export default component.exports